import { component_tool, framework_tool } from '../../../tool';
let { WizModal, WizNotice } = component_tool;
import moment from "moment";
import React from 'react';
let { WizDataTable, WizIcon, WizButton, WizDivider, WizSurveyAudience, WizTypography, WizRow } = component_tool
let { WizAvatarUpload, ossFileUtils } = framework_tool
import LinkView from './linkView'
import HighSet from "@/containers/common/highSet";
import AuthVideo from "../../face/class/classStudent/classStudentRemoteAuth/authVideo";
import {WizDataAuthSelect } from '@/containers/common'
let ref;
let ref_;
//配置项
let componentName = 'interactLive'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "直播名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "直播类型",
    name: "liveType",
    dataIndex: "liveType",
    tableItem: {},
    searchItem: {
      type: 'select',
    },
    dict: [
      { code: 1, codeName: "视频直播" },
      // { code: 2, codeName: "互动直播" },
      // { code: 3, codeName: "点播" },
      { code: 4, codeName: "远程认证" },
      { code: 5, codeName: "直播课堂" },
      { code: 6, codeName: "远程评估" },
      { code: 7, codeName: "企微会议" },
      { code: 8, codeName: "企微直播" },
    ],
  },
  {
    title: "观看类型",
    name: "watchType",
    dataIndex: "watchType",
    tableItem: {},
    searchItem: {
      type: 'select',
    },
    dict: [
      { code: 1, codeName: "横屏" },
      { code: 2, codeName: "竖屏" },
    ],
  },

  {
    title: "直播分类",
    name: "categoryName",
    dataIndex: "categoryName",
    tableItem: {}
  },

  {
    title: "开播时间",
    name: "startDate",
    dataIndex: "startDate",
    width: 150,
    tableItem: {}
  },
  {
    title: '视频工具',
    name: "videoTool",
    tableItem: {},
    dict: [
        { code: 1, codeName: "中目" },
        { code: 2, codeName: "慧课堂" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "直播状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "草稿" },
      { code: 2, codeName: "预告中" },
      { code: 3, codeName: "直播中" },
      { code: 4, codeName: "已结束" }
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "直播房间",
    name: "ownerId",
    dataIndex: "ownerId",
    tableItem: {}
  },
  {
    title: "是否允许匿名互动",
    name: "anonymous",
    dataIndex: "anonymous",
    tableItem: {},
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" },
    ],
    searchItem: {
      type: "select"
    },
  },

  {
    title: "开播时间",
    name: "searchDate",
    dataIndex: "searchDate",
    searchItem: {
      type: 'date~',
      showTime: true,
      format: 'YYYY-MM-DD HH:mm:ss'
    }
  }

];

const templateConfig =(data)=> {
  const { self } = data;
  return {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        dataFormat: (val) => {
          if (val['searchDate'] && val['searchDate'].length === 2) {
            val['startDate'] = moment(val['searchDate'][0]).format("YYYY-MM-DD HH:mm:ss")
            val['endDate'] = moment(val['searchDate'][1]).format("YYYY-MM-DD HH:mm:ss")
          }else{
            val['startDate'] = undefined;
            val['endDate'] = undefined;
          }
          // delete val['searchDate']
          return val
        },
        buttonSort: ['add', 'delete', "exportLiveInfo"],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/live/liveList/liveAdd"
              }
            }
          },
          {
            key: "exportLiveInfo",
            custom: true,
            params: { icon: 'export', children: '导出直播信息', type: 'export'},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "export"
              },
              formatParams: (rows, record, filter) => {
                return { ...filter };
              }
            }
          },
          // {
          //   key: "updateTrainingStatistics",
          //   custom: true,
          //   params: { icon: 'reload', children: '更新参训统计数据', type: 'reload'},
          //   customOnClick: {
          //     key: "action",
          //     params: {
          //       apiKey: "syncLiveTrack"
          //     },
          //     formatParams: (rows, record, filter) => {
          //       let ids = [];
          //       if (rows && rows instanceof Array) {
          //         rows.forEach(element => {
          //           ids.push(element.id)
          //         });
          //       }
          //       return {
          //         ids: ids
          //       };
          //     }
          //   }
          // },
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
        // expandedRowRender: (record) => {
        //   return (
        //     <>
        //     <WizRow>
        //       <WizTypography.Paragraph strong>直播受众：</WizTypography.Paragraph>
        //     </WizRow>
        //     <WizSurveyAudience style={{width:1000}} labelWidth={4} data={record['authData']||{}} />
        //     </>
        //   )
        // }
      },
      rowOperateSort: ['update', 'liveLink','videoManagement', 'look', 'notice', 'release', 'close', 'viewTrainingRecords','participationStatisticsManagement', 'exportAudience','videoPlayback','advancedSet','authSetting','exportContent'],// 'manager',
      rowOperateView: [

        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/live/liveList/liveUpd"
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: false };
            if (record.record && record.record.liveType ===5 && record.record.state!=1) {
              result.disabled = true
            }
            return result
          },
        },
        {
          key: "liveLink",
          custom: true,
          params: { children: "链接" },
          customOnClick: {
            key: "modal",
            params: {
              modalKey: "linkModal",
              modalParams: {
                title: "直播链接",
                cancelButtonProps: { style: { height: 0, width: 0 } },
                style: { minWidth: 700 },
                footer: null,
                diy: (e) => {
                  return (
                    <LinkView
                      id={e.record.id}
                      type={e.record.liveType}
                    />
                  )
                },
                onOk: () => {},
                width: 700
              },
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.liveType ===1) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "videoManagement",
          custom: true,
          params: { children: "视频管理" },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "getWebUploadBackPlayUrl",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              callback({
                liveType:record.liveType,
                id:record.id,
              })
              // window.open(record.loginUrl, '_blank')
              // return null
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true, hidden: true };
            if (record.record && record.record.liveType ===1) {
              result.disabled = false
              if ( record.record.liveVideoType ===4){
                result.hidden = false
              }
            }
            return result
          },
        },
        {
          key: "look",
          custom: true,
          params: { children: "查看" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/live/liveList/liveInfo"
            }
          }
        },
        {
          key: "notice",
          custom: true,
          params: { children: "预告"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "setInteractLiveState"
            },
            formatParams: (rows, record, filters, callback) => {
              const content = '您确定修改[' + record.name + ']状态为预告中吗?'
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: 2,
                    id: record['id'],
                  })
                },
                onCancel() { }
              });
              return null
            },
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.state === 1) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "release",
          custom: true,
          params: { children: "发布"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "setInteractLiveState"
            },
            formatParams: (rows, record, filters, callback) => {
              const content = '您确定修改[' + record.name + ']状态为直播中吗?'
              if (record.state == 3) {
                WizNotice.warn('该直播已是直播中状态,不可重复操作');
                return null;
              }
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: 3,
                    id: record['id'],
                  })
                },
                onCancel() { }
              });
              return null
            },
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && (record.record.state === 1 || record.record.state === 2)) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "close",
          custom: true,
          params: { children: "关闭"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "setInteractLiveState"
            },
            formatParams: (rows, record, filters, callback) => {
              const content = '您确定修改[' + record.name + ']状态为已结束吗?'
              if (record.state == 4) {
                WizNotice.warn('该直播已是结束状态,不可重复操作');
                return null;
              }
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: 4,
                    id: record['id'],
                  })
                },
                onCancel() { }
              });
              return null
            },
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.state === 3) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "viewTrainingRecords",
          custom: true,
          params: { children: "查看参训记录"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/live/liveList/LiveRecordList"
            }
          }
        },
        {
          key: "manager",
          custom: true,
          params: { children: "考核规则管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/live/liveList/liveTrain/assessmentRulesList"
            }
          }
        },
        {
          key: "participationStatisticsManagement",
          custom: true,
          params: { children: "参训统计管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/live/liveList/liveStatisticsList"
            }
          }
        },
        {
          key: "exportAudience",
          custom: true,
          params: { children: "导出受众人员"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "exportLiveAuthInfo"
            },
            formatParams: (rows, record, filters, callback) => {
              callback && callback({
                id: record['id'],
              })
              return null
            },
          }
        },

        {
          key: "videoPlayback",
          custom: true,
          params: { children: "录像回放"},
          customOnClick: {
            key: "modal",
            params: {
              modalKey: "playbackModal",
              modalParams: {
                title: "录像回放",
                diy: (e) => {
                  e.record = Object.assign({}, e.record);
                  return (
                    <AuthVideo
                      key={'authVideo-'+e.record.id}
                      {...e}
                      type={0}
                      ref={r => {
                        ref_ = r && r.getWrappedInstance();
                      }}
                    />
                  )
                },
                footer:null,
                width: 700
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            let liveType = record.record.liveType
            let state = record.record.state
            //直播类型为远程认证 直播课程 远程评估 才有回看
            if((liveType ===4 || liveType ===5 || liveType ===6) && state ===4){
              result.disabled = false
            }
            return result
          },
        },



        {
          key: 'advancedSet',
          custom: true,
          params: {children: '高级设置'},
          customOnClick: {
            key: 'modal',
            params: {
              modalParams: {
                title: '高级设置',
                bordered: true,
                footer: null,
                destroyOnClose: true,
                diy: (e) => {
                  return <>
                    <HighSet data={{record: e.record,bizType: 26}}
                             changeModal={e.changeModal}
                    />
                  </>
                },
                width: 950
              },
            }
          },
          recordChangeParams: ({record, rows}) => {
            let disabled = false
            if (record && record['state'] !== 1 && record['state'] !== 2 && record['state'] !== 3) {
              disabled = true
            }
            return {disabled}
          }
        },

        {
          key: 'authSetting',
          custom: true,
          params: { children: '受众设置' },
          customOnClick: {
            key: 'modal',
            params: {
              modalParams: {
                title: '受众设置',
                bordered: true,
                footer: null,
                destroyOnClose: true,
                diy: (e) => {
                  return <>
                    <WizDataAuthSelect 
                      value = {e.record.authInfo}
                      onSubmit ={(values)=>{self._saveAuth(values,e.changeModal)}} 
                      bizType = {26}
                      bizId = {e.record.id}
                      changeModal={e.changeModal}
                    />
                  </>
                },
                width: 950
              },
            }
          },
          recordChangeParams: ({ record, rows }) => {
            return {disabled: record.liveType!=1}
          }
        },

        {
          key: "exportContent",
          custom: true,
          params: { children: "导出直播内容"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "exportContent"
            },
            formatParams: (rows, record, filters, callback) => {
              callback && callback({
                liveId: record['id'],
              })
              //return {id: record.id}
              return null
            },
          },
        },
      ],
      commonOperate: {}
    }
  }
}};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {}
    }
  },
  setLiveStatus: {
    path: `${componentName}/setLiveStatus`,
    payload: {
      key: `${componentName}@setLiveStatus`,
      apiParams: {}
    }
  },
  getWebUploadBackPlayUrl:{
    path: `${componentName}/getWebUploadBackPlayUrl`,
    payload: {
      key: `${componentName}@getWebUploadBackPlayUrl`,
      apiParams: {}
    }
  },
  exportLive: {
    path: `${componentName}/listByCondition`,
    payload: {
      key: `${componentName}@listByCondition`,
      apiParams: {}
    }
  },
  // syncLiveTrack: {
  //   path: `${componentName}/listByCondition`,
  //   payload: {
  //     key: `${componentName}@listByCondition`,
  //     apiParams: {}
  //   }
  // },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  setInteractLiveState: {
    path: `${componentName}/setInteractLiveState`,
    payload: {
      key: `${componentName}@setInteractLiveState`,
      apiParams: {}
    }
  },
  exportLiveAuthInfo: {
    path: `${componentName}/exportLiveAuthInfo`,
    payload: {
      key: `${componentName}@exportLiveAuthInfo`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  exportContent: {
    path: `${componentName}/exportContent`,
    payload: {
      key: `${componentName}@exportContent`,
      apiParams: {}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
